



























import { defineComponent } from "@vue/composition-api";
import { StereoFormat } from "@scrile/api-provider/dist/api/FileProvider";
import { PostFileData } from "@/types";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIconButton from "@/components/BaseIconButton";

export default defineComponent({
  name: "SelectVideoFormatModal",
  components: { BaseConfirm, BaseIconButton },
  props: {
    show: { type: Boolean, required: true },
    file: { type: Object as () => PostFileData | null },
  },
  data() {
    return {
      types: [
        {
          type: StereoFormat.STEREO_180_LR,
          text: this.$t("A 180 degree stereo equirectangular mapping, left and right eye being side by side."),
        },
        {
          type: StereoFormat.STEREO_180_LR_SPHERICAL,
          text: this.$t("A 180 degree stereo spherical mapping, left and right eye being side by side."),
        },
        {
          type: StereoFormat.STEREO_180_TB,
          text: this.$t(
            "A 180 degree stereo equirectangular mapping, left and right eye being on top and bottom respectively."
          ),
        },
        {
          type: StereoFormat.STEREO_180_TB_SPHERICAL,
          text: this.$t(
            "A 180 degree stereo spherical mapping, left and right eye being on top and bottom respectively."
          ),
        },
        {
          type: StereoFormat.STEREO_360_TB,
          text: this.$t(
            "A 360 degree stereo equirectangular mapping, left and right eye being on top and bottom respectively."
          ),
        },
        {
          type: StereoFormat.STEREO_360_LR,
          text: this.$t("A 360 degree stereo equirectangular mapping, left and right eye being side by side."),
        },
        {
          type: StereoFormat.MONO_360,
          text: this.$t("A 360 degree mono equirectangular mapping."),
        },
        {
          type: StereoFormat.STEREO_FLAT_LR,
          text: this.$t(
            "A stereoscopic 3D flat video, left and right eye being side by side. The pixel aspect ratio follows the video aspect ratio."
          ),
        },
        {
          type: StereoFormat.STEREO_FLAT_LR_SQUARE,
          text: this.$t(
            "A stereoscopic 3D flat video, left and right eye being side by side. The pixel aspect ratio is square (1:1)."
          ),
        },
        {
          type: StereoFormat.STEREO_FLAT_TB,
          text: this.$t(
            "A stereoscopic 3D flat video, left and right eye being on top and bottom respectively. The pixel aspect ratio follows the video aspect ratio."
          ),
        },
        {
          type: StereoFormat.STEREO_FLAT_TB_SQUARE,
          text: this.$t(
            "A stereoscopic 3D flat video, left and right eye being on top and bottom respectively. The pixel aspect ratio is square (1:1)."
          ),
        },
      ],
    };
  },
  computed: {
    currentType(): string {
      return this.file?.metadata?.stereoFormat ?? "";
    },
  },
});
